import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If navigating to a hash (e.g. /#contact-us), DO NOT scroll to top
    if (hash) return;

    // Immediately scroll to top
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Force layout recalculation by resetting heights
    const originalBodyHeight = document.body.style.height;
    const originalHtmlHeight = document.documentElement.style.height;

    document.body.style.height = "auto";
    document.documentElement.style.height = "auto";

    // Force reflow
    void document.body.offsetHeight;
    void document.documentElement.offsetHeight;

    let timer: NodeJS.Timeout | null = null;

    // Use requestAnimationFrame to ensure DOM is ready
    const rafId = requestAnimationFrame(() => {
      // Scroll again to ensure it's at the top
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // Reset heights after a brief moment to let content render
      timer = setTimeout(() => {
        // Remove inline styles to let CSS take over
        document.body.style.height = originalBodyHeight || "";
        document.documentElement.style.height = originalHtmlHeight || "";

        // Final scroll to top
        window.scrollTo(0, 0);

        // Force a layout recalculation
        void document.body.offsetHeight;
      }, 100);
    });

    return () => {
      cancelAnimationFrame(rafId);
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
